import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

class Message {
  constructor({ text, type = 'error' }) {
    this.text = text
    this.type = type
  }
}

export default new Vuex.Store({
  state: {
    notify: null
  },
  getters: {
    hasNotifications(state) {
      return Boolean(state.notify)
    },
    notify(state) {
      return state.notify
    }
  },
  mutations: {
    SET_NOTIFICATION(state, message) {
      state.notify = new Message(message)
      setTimeout(() => {
        state.notify = null
      }, 1500)
    },
    CLEAR_NOTIFICATION(state) {
      state.notify = null
    }
  },
  actions: {
  },
  modules: {
  }
})
